import { Color } from '@diritto/common/style/color';
import { IconProps } from '@diritto/common/style/icon';

export const CalendarIcon = ({ size = 24, color = Color.Gray400 }: IconProps) => (
  <svg width={size} height={(size * 17) / 16} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.46304 15.1666C3.05837 15.1666 2.71336 15.023 2.42802 14.7358C2.14267 14.4485 2 14.1012 2 13.6939V4.26183C2 3.85446 2.14267 3.50455 2.42802 3.21208C2.71336 2.91962 3.05837 2.77338 3.46304 2.77338H4.33463V1.83331H5.6109V2.77338H10.3735V1.83331H11.6498V2.77338H12.5214C12.9261 2.77338 13.2737 2.91962 13.5642 3.21208C13.8547 3.50455 14 3.85446 14 4.26183V13.6939C14 14.1012 13.8547 14.4485 13.5642 14.7358C13.2737 15.023 12.9261 15.1666 12.5214 15.1666H3.46304ZM3.46304 13.6939H12.5214V7.09771H3.46304V13.6939Z"
      fill={color}
    />
  </svg>
);
